import { useReduxState } from "hooks/useReduxState";

export const useIpAuthFlg = () =>
  useReduxState(s => s.auth.saved.user.ipAuthFlg);
